import React, { useState, useRef, useEffect } from "react";; 
import ExpandSVG from "../../assets/ExpandSVG";
import { Link } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';

import '../UserDropdown/UserDisplay.css'

const OtherFormsButton = () => { 
    const [open, setOpen] = useState(false);
    const node = useRef();
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  
    const toggleDropdown = () => setOpen(!open);

    useEffect(() => {
      // add when mounted
      document.addEventListener("mousedown", handleClick);
      // return function to be called when unmounted
      return () => {
        document.removeEventListener("mousedown", handleClick);
      };
  }, []);

  const handleClick = e => {
      if (node.current.contains(e.target)) {
        // inside click
        return;
      }
      // outside click 
      setOpen(false);
  };
  
    return (
      <div ref={node} className="m-0 p-0 !important">
        <button className="flex items-center cursor-pointer text-[11px] md:text-[13px] bg-slate-200 text-shi-green md:px-2 md:py-1 px-[2px] py-[4px] hover:bg-slate-400 rounded-md" onClick={toggleDropdown}>
          FORMS
          {isMobile ? 
              (open ? 
                  <div className="rotate-180"><ExpandSVG fill="#000000" width={15} height={15}/></div> 
                  : <ExpandSVG fill="#000000" width={15} height={15}/>
              ) 
              : 
              (open ? 
                  <div className="rotate-180"><ExpandSVG fill="#000000" /></div> 
                  : <ExpandSVG fill="#000000"/>
              )
          }
        </button>
        {open && (
          <div className="modal-dropdown">
            <ul>
              <li><Link to="/amendextend">Amend Extend</Link></li>
              <li><Link to="https://drive.google.com/file/d/1A3OFP2UGtjBCk8AbpiohQ1RvS1sgfpgx/view?usp=sharing" target="_blank" rel="noopener noreferrer">Notice to Terminate</Link></li>
              <li><Link to="https://drive.google.com/file/d/1EbWUq_S6f85_-OZ6ESPaI-L_YXE71T40/view" target="_blank" rel="noopener noreferrer">Post Closing Occupancy Agreement</Link></li>
              <li><Link to="https://drive.google.com/file/d/12pJoxuF-Mn6isBUF1AGbSrjRwNqBat0I/view?usp=sharing" target="_blank" rel="noopener noreferrer">Inspection Objection Notice</Link></li>
              <li><Link to="https://drive.google.com/file/d/1kEODoBEsPj_KFBlZ8HHF6x7J3QyH_Nzp/view?usp=sharing" target="_blank" rel="noopener noreferrer">Inspection Resolution</Link></li>
              <li><Link to="https://drive.google.com/file/d/10akm2G01kttmqtnssYu4ZPKhVYV0lkCM/view?usp=sharing" target="_blank" rel="noopener noreferrer">Appraisal Objection Notice</Link></li>
              <li><Link to="https://drive.google.com/file/d/1p6IbgX5oLP1xlSI78PJ7y5tFeYeWysGh/view?usp=sharing" target="_blank" rel="noopener noreferrer">Title Objection Notice</Link></li>
              <li><Link to="https://drive.google.com/file/d/19VZlUwy3i1oTGCDtF045oBksJvJh53g_/view?usp=sharing" target="_blank" rel="noopener noreferrer">Counterproposal</Link></li>
            </ul>
          </div>
        )}
      </div>
    );
  };
  
  export default OtherFormsButton;